import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
/**Estados */
const state = {
    /**Variables de estado */
    asistente_step: '',
    titulo_span: '',
    marca: '',
    velocimetro: false,
    cotizacion: {},
    pendiente: false,
    selection_data: {
        marca_name: '',
        marca_id: '',
        modelo: '',
        linea_name: '',
        linea_id: '',
        version_id: '',
        modelorel_id: '',
        version_name: '',
        color: '',
        kilometraje: 0,
    },
    form_data: {
        marcas: [],
        modelos: [],
        lineas: [],
        versiones: [],
    }
};
/**Esto son funciones que modifican el estado original */
const mutations = {
    updateField
};
/**Esta funcion trae valores de los estados */
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
